<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
		created(){
			axios.get('/agent/customer/service/token').then((response)=>{
				if (response.data.msg.code == 0) {
					// var user_id = response.data.data.id
					if(response.data.data.customer_service_open){
					var isShowTip = true
					}else{
					var isShowTip = false
					}

					var usetoken = response.data.data.customer_service_token
					var usekefuid = response.data.data.yun_cust_id




					var _s = document.createElement('script');
					_s.src="http://kf.xiaoluohao.vip/customerServer.js"
					_s.onload = function(){
					var option = {
						"authInit":true,
						openUrl: 'http://kf.xiaoluohao.vip',
						token: usetoken,
						kefuid:usekefuid,//默认为空自动对接客服，可填写指定客服ID
						isShowTip: isShowTip, // 初始化成功后，界面右下角会自动创建 “联系客服按钮”， 如无需默认展示，则填写false即可,默认为true
						mobileIcon: '', //  手机端悬浮客服图片
						pcIcon: '', // pc端悬浮客服图片
						windowStyle:'center',//默认空 右下角小弹窗， center 普通中间弹窗样式
						 sendUserData: {
								nickName: JSON.parse(localStorage.getItem('user')).name, // 用户昵称
							}
						};


						var canCustomerServer = new initCustomerServer(option);

						canCustomerServer.init();
					}
					// document.head.replaceChild(_s)
					document.head.appendChild(_s)



				} else {
				this.$message.error(response.data.msg.info);
				}
			})
		}
	}
</script>

<style lang="less">
	@import "~@/assets/all.less";
</style>



// WEBPACK FOOTER //
// src/App.vue